type PlusIconProps = {
  color: string;
};

export const PlusIcon = ({ color }: PlusIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 21 21"
  >
    <path
      data-name="Tracé 8241"
      d="M8.8 18.482H.656v-3.589H8.8V6.667h3.685v8.226h8.168v3.589h-8.165v8.185H8.8z"
      transform="translate(-.156 -6.167)"
      fill={color}
      stroke={"transparent"}
    />
  </svg>
);
